// API route constants intentionally share paths when their HTTP methods distinguish the operation.
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ApiRoutesEnum {
  getMatchingStatus = '/python/candidate-project-matching/status',
  updateMatchingSettings = '/python/candidate-project-matching/settings',
  login = '/user/login',
  getCandidate = '/candidates/:id',
  recommendedProjects = '/candidates/:id/recommended-projects',
  recommendedCandidates = '/projects/:id/recommended-candidates',
  candidateProjectMatch = '/candidate-project-matches/:candidateUuid/:projectUuid',
  getCandidateRecruitment = '/candidates/:id/recruitment',
  getCandidateReminders = '/candidates/:id/reminders',
  addCandidate = '/candidates',
  anonymiseCandidate = '/candidates/:id/anonymize',
  updateCandidate = '/candidates/:id',
  searchCandidates = 'candidates/search',
  candidateAddNote = '/candidates/:id/notes',
  candidateUpdateNote = '/candidates/:candidateId/notes/:noteId',
  candidatesFilters = 'candidates/search/options',
  candidatesSaveFilter = 'candidates/search/options/filters',
  candidatesDeleteFilter = 'candidates/search/options/filters/:id',
  candidatesUpdateFilter = 'candidates/search/options/filters/:id',
  candidateAttachFile = 'candidates/:id/files',
  candidateDownloadFile = 'candidates/:candidateId/files/:fileId',
  getCandidateAiReviewState = '/candidates/:id/ai/review-state',
  candidateAiReviewActions = '/candidates/:id/ai/review-actions',
  getCandidateAiParsedCv = '/candidates/:id/ai/parsed-cv',
  getConsentTemplates = '/candidate/consent/template',
  addConsentTemplate = '/candidate/consent/template',
  addCandidateConsents = '/candidate/consent',
  updateCandidateConsents = '/candidate/consent/update',
  addClient = '/clients',
  addClientEmployee = '/clients/:clientId/employees',
  getClient = '/clients',
  updateClient = '/clients/:id',
  updateClientEmployee = '/clients/:clientId/employees/:employeeId',
  searchClients = 'clients/search',
  clientsFilters = 'clients/search/options',
  clientsSaveFilter = 'clients/search/options/filters',
  clientsDeleteFilter = 'clients/search/options/filters/:id',
  clientsUpdateFilter = 'clients/search/options/filters/:id',
  searchProjects = 'projects/search',
  searchSimilarProjects = 'projects/similar',
  searchSimilarProjectsBySource = 'projects/:uuid/similar',
  getProject = '/projects',
  addProject = '/projects',
  updateProject = '/projects/:id',
  projectsFilters = 'projects/search/options',
  projectsSaveFilter = 'projects/search/options/filters',
  projectsDeleteFilter = 'projects/search/options/filters/:id',
  projectsUpdateFilter = 'projects/search/options/filters/:id',
  searchUsers = 'users/search',
  getRecruitment = '/recruitments',
  addRecruitment = '/recruitments',
  updateRecruitment = '/recruitments/:id',
  searchRecruitments = 'recruitments/search',
  recruitmentAddNote = '/recruitments/:id/notes',
  recruitmentsBulkClone = 'recruitments/bulk/clone',
  recruitmentsBulkUpdate = '/recruitments/bulk/update',
  recruitmentsFilters = 'recruitments/search/options',
  recruitmentsSaveFilter = 'recruitments/search/options/filters',
  recruitmentsDeleteFilter = 'recruitments/search/options/filters/:id',
  recruitmentsUpdateFilter = 'recruitments/search/options/filters/:id',
  recruitmentsUpdateNote = '/recruitments/:id',
  recruitmentsUpdateBulkNote = '/recruitments',
  recruitmentAddStatusDefinition = 'recruitments/status',
  recruitmentUpdateStatusDefinition = 'recruitments/status/:id',
  recruitmentStatuses = 'recruitments/status',
  reminders = '/reminders',
  searchReminders = 'reminders/search',
  remindersFilters = 'reminders/search/options',
  remindersSaveFilter = 'reminders/search/options/filters',
  remindersDeleteFilter = 'reminders/search/options/filters/:id',
  remindersUpdateFilter = 'reminders/search/options/filters/:id',
  searchCandidateReminders = '/candidates/:id/reminders',
  searchProjectReminders = '/projects/:id/reminders',
  dictionaryCities = 'dictionaries/cities',
  dictionaryDeleteItem = 'dictionaries/:dictionary/:id',
  dictionaryMergeItems = 'dictionaries/:dictionaryName/:id/replace',
  dictionaryRecommenders = 'dictionaries/recommenders',
  dictionarySaveItem = 'dictionaries/:dictionary',
  dictionaryUpdateItem = 'dictionaries/:dictionary/:id',
  fileStorage = '/filestorage',
  searchEmails = '/emails/search',
  getEmail = '/emails',
  emailsFilters = 'emails/search/options',
  emailsSaveFilter = 'emails/search/options/filters',
  emailsDeleteFilter = 'emails/search/options/filters/:id',
  emailsUpdateFilter = 'emails/search/options/filters/:id',
  getDictionaries = '/dictionaries',
}

export enum PageRoutesEnum {
  matchingAdmin = '/admin/matching',
  main = '/',
  login = '/login',
  candidates = '/candidates',
  emailConvert = '/email/convert',
  candidateEdit = '/candidates/:id',
  candidateMatches = '/candidates/:id/matches',
  candidateMatchDetails = '/candidates/:id/matches/:matchId',
  candidateCvSuggestions = '/candidates/:id/cv-suggestions',
  candidateAdd = '/candidates/add',
  clientAdd = '/clients/add',
  clientEdit = '/clients/:id',
  dashboard = '/dashboard',
  dictionaries = '/dictionaries',
  emails = '/emails',
  emailDetails = '/emails/:id',
  recruitments = '/recruitments',
  recruitmentEdit = '/recruitments/:id',
  recruitmentAdd = '/recruitments/add',
  clients = '/clients',
  projects = '/projects',
  projectsEdit = '/projects/:id',
  projectMatches = '/projects/:id/matches',
  projectMatchDetails = '/projects/:id/matches/:matchId',
  projectAdd = '/projects/add',
  reminders = '/reminders',
  reminderEdit = '/reminders',
  consents = '/consents',
}
